import React from 'react';
import { useEffect } from 'react';

import FilterChips from '../filters/FilterChipsSessions';

import useStore from '../../store/useStore';
import {
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  ButtonGroup,
  Button,
} from '@mui/material';



//for checkbox select
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';

import Select, { SelectChangeEvent } from '@mui/material/Select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFilter,
  faList,
  faBorderAll,
} from '@fortawesome/free-solid-svg-icons';
import { ChevronDown } from '@carbon/icons-react';
import ButtonComponent from '../button';
import { HiOutlineViewGrid } from 'react-icons/hi';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { List, Calendar } from '@carbon/icons-react';
import { useNavigate } from "react-router-dom";

const FilterBarSessions = () => {

  //const navigate = useNavigate();

  const {

    setParams,
    darkTheme,


    //view /*filters, view, settings*/
  } = useStore((state: any) => ({

    setParams: state.setParams,
    darkTheme: state.settings.params.darkTheme,


  }));

  const navigateEvents = () => {
    console.log("Navigate to events ");
    // navigate("/");
    setParams('type', 'events')
    setParams('activeRoute', 'events')
    setParams('eventid', '')


  };
  const {
    eventid,
    view,
    filters,
    meetingtypes,
    committees,
    subgroups,
    venues,
    agendaitems,
    dateSessions,
    sectorssessions,
    settings: {
      params: { displayviewswitch },
    },
    displayfilters,
    changeView,
    setFilter,
    //filters: { SectorSession },
  } = useStore((state: any) => ({
    eventid: state.settings.params.eventid,
    view: state.settings.params.view,
    filters: state.filters,
    meetingtypes: state.meetingtypes,
    committees: state.committees, //committee
    subgroups: state.subgroups,
    venues: state.venues,
    agendaitems: state.agendaitems,
    dateSessions: state.dateSessions,
    sectorssessions: state.sectorssessions,
    settings: state.settings,
    displayfilters: state.settings.params.displayfilters,
    changeView: state.changeView,
    setFilter: state.setFilter,
    //filters: state.filters,
  }));

  const { cards } = useStore((state: any) => ({ cards: state.MUIdataSessions.rows }));

  const [selectedSector, setSelectedSector] = React.useState<string[]>([]);
  const [selectedMeetingtypes, setSelectedMeetingtypes] = React.useState<string[]>([]);
  const [selectedCommittees, setSelectedCommittees] = React.useState<string[]>([]);
  const [selectedSubGroups, setSelectedSubGroups] = React.useState<string[]>([]);
  const [selectedVenues, setSelectedVenues] = React.useState<string[]>([]);
  const [selectedAgendaitems, setSelectedAgendaitems] = React.useState<string[]>([]);



  const handleChangeSector = (event: any) => {
    const {
      target: { value }
    } = event;

    let valueSelect = (typeof value === "string" ? value.split(",") : value);
    //set selected sector value
    setSelectedSector(valueSelect);

    //console.log(valueSelect);
    //set filter value and rebuild data
    setFilter('SectorSession', valueSelect);
  };


  const handleChangeMeetingtypes = (event: any) => {
    const {
      target: { value }
    } = event;

    let valueSelect = (typeof value === "string" ? value.split(",") : value);

    console.log(valueSelect);

    //set selected group value
    setSelectedMeetingtypes(valueSelect);

    //set filter value and rebuild data
    setFilter('MeetingType', valueSelect);
  };



  const handleChangeCommittees = (event: any) => {
    const {
      target: { value }
    } = event;

    let valueSelect = (typeof value === "string" ? value.split(",") : value);

    console.log(valueSelect);

    //set selected group value
    setSelectedCommittees(valueSelect);

    //set filter value and rebuild data
    setFilter('Committee', valueSelect);
  };


  const handleChangeSubGroups = (event: any) => {
    const {
      target: { value }
    } = event;

    let valueSelect = (typeof value === "string" ? value.split(",") : value);

    console.log(valueSelect);

    //set selected group value
    setSelectedSubGroups(valueSelect);

    //set filter value and rebuild data
    setFilter('SubGroup', valueSelect);
  };

  const handleChangeVenues = (event: any) => {
    const {
      target: { value }
    } = event;

    let valueSelect = (typeof value === "string" ? value.split(",") : value);

    console.log(valueSelect);

    //set selected group value
    setSelectedVenues(valueSelect);

    //set filter value and rebuild data
    setFilter('Venue', valueSelect);
  };


  const handleChangeAgendaitems = (event: any) => {
    const {
      target: { value }
    } = event;

    let valueSelect = (typeof value === "string" ? value.split(",") : value);

    console.log(valueSelect);

    //set selected group value
    setSelectedAgendaitems(valueSelect);

    //set filter value and rebuild data
    setFilter('Agendaitem', valueSelect);
  };


  //watch changes to filters (useful when resetting value by filterchips)
  useEffect(() => {
    // watch change on filter sector
    //console.log(filters.SectorSession)
    if (filters.SectorSession == '')
      setSelectedSector([]); //reset select box value to empty array
    if (filters.MeetingType == '')
      setSelectedMeetingtypes([]); //reset select box value to empty array
    if (filters.Venue == '')
      setSelectedVenues([]); //reset select box value to empty array
    if (filters.Committee == '') //committee
      setSelectedCommittees([]); //reset select box value to empty array
    if (filters.SubGroup == '')
      setSelectedSubGroups([]); //reset select box value to empty array
    if (filters.Agendaitem == '')
      setSelectedAgendaitems([]); //reset select box value to empty array
  }, [filters.SectorSession, filters.MeetingType, filters.Venue, filters.Committee, filters.SubGroup, filters.Agendaitem])

  const setView = (
    newView: string,
  ) => {
    if (newView !== null) {
      changeView(newView);
    }
  };

  const filterDivStyleDark={ display: 'none', width: '100%', padding: '0 0 1.5rem 0', backgroundColor: "#293336", margin: "0px", paddingRight: "10px" }
  const filterDivStyleLight={ display: 'none', width: '100%', padding: '0 0 1.5rem 0',  margin: "0px", paddingRight: "10px" }

  const selectLabelStyleDark={ color: '#fff' }
  const selectLabelStyleLight={}

  const selectPropsStyleDark={ backgroundColor: '#182124', color: '#fff' }
  const selectPropsStyleLight={ fill: '#000' }

  const selectIconLight= {
     
      "& .MuiSvgIcon-root": {
        color: "darkred",
      },
    }
  const selectIconDark= {
     
      "& .MuiSvgIcon-root": {
        color: "white",
      },
    }
  

  return (
    <>
      <div id='FilterBarSessions' style={darkTheme === '1' ? filterDivStyleDark : filterDivStyleLight}>
        <div className='ituContainer grid'>


          {/* Sectors filter */}
          {displayfilters?.sectorsession === 1 ? (
            <div data-span="2">
              <FormControl variant="filled" id={
            darkTheme === '1' ? 'filterApp' : 'noFilterApp'}  fullWidth>
                <InputLabel id="sector-sessions-filter-select-label"
                  style={darkTheme === '1' ? selectLabelStyleDark : selectLabelStyleLight}
                  disableAnimation={true}
                  shrink={false}
                >
                  Sector
                </InputLabel>
                <Select
                  sx={darkTheme === '1' ? selectIconDark : selectIconLight}
                  inputProps={{ MenuProps: { MenuListProps: { sx: darkTheme === '1' ? selectPropsStyleDark : selectPropsStyleLight } } }}
                  IconComponent={ChevronDown}
                  variant="filled"
                  style={darkTheme === '1' ? selectLabelStyleDark : selectLabelStyleLight}
                  id="sector-sessions-filter"
                  labelId="sector-sessions-filter-select-label"
                  multiple
                  value={selectedSector}
                  //disabled={filters.SectorSession.length > 0}
                  onChange={handleChangeSector}
                  renderValue={() => ""}
                >
                  {sectorssessions.map((sectorItem: any) => (
                    <MenuItem key={sectorItem} value={sectorItem}>
                      <Checkbox checked={selectedSector.indexOf(sectorItem) > -1} />
                      <ListItemText primary={sectorItem} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          ) : null
          }

          {/* Meeting Session Type filter */}
          {displayfilters?.meetingtype === 1 ? (
            <div data-span="2">
              <FormControl variant="filled"  id={
            darkTheme === '1' ? 'filterApp' : 'noFilterApp'} fullWidth>
                <InputLabel id="meetingtypes-sessions-filter-select-label"
                  style={darkTheme === '1' ? selectLabelStyleDark : selectLabelStyleLight}
                  disableAnimation={true}
                  shrink={false}
                >
                  Type
                </InputLabel>

                <Select
                  sx={darkTheme === '1' ? selectIconDark : selectIconLight}
                  inputProps={{ MenuProps: { MenuListProps: { sx: darkTheme === '1' ? selectPropsStyleDark : selectPropsStyleLight } } }}
                  IconComponent={ChevronDown}
                  variant="filled"
                  style={darkTheme === '1' ? selectLabelStyleDark : selectLabelStyleLight}
                  id="meetingtypes-sessions-filter"
                  labelId="meetingtypes-sessions-filter-select-label"
                  multiple
                  value={selectedMeetingtypes}
                  onChange={handleChangeMeetingtypes}
                  renderValue={() => ""}
                >
                  {meetingtypes.map((item: any) => (
                    <MenuItem key={item} value={item}>
                      <Checkbox checked={selectedMeetingtypes.indexOf(item) > -1} />
                      <ListItemText primary={item} style={{ width: 'fit-content' }} />
                    </MenuItem>
                  ))}
                </Select>

              </FormControl>
            </div>
          ) : null
          }

          {/* Committee  filter */}
          {displayfilters?.committee === 1 ? (

            <div data-span="2">
              <FormControl variant="filled" id={
            darkTheme === '1' ? 'filterApp' : 'noFilterApp'}  fullWidth>
                <InputLabel id="committee-sessions-filter-select-label"
                  style={darkTheme === '1' ? selectLabelStyleDark : selectLabelStyleLight}
                  disableAnimation={true}
                  shrink={false}
                >
                  Committee
                </InputLabel>

                <Select
                 sx={darkTheme === '1' ? selectIconDark : selectIconLight}
                 inputProps={{ MenuProps: { MenuListProps: { sx: darkTheme === '1' ? selectPropsStyleDark : selectPropsStyleLight } } }}
                 IconComponent={ChevronDown}
                 variant="filled"
                 style={darkTheme === '1' ? selectLabelStyleDark : selectLabelStyleLight}
                  id="committee-committee-sessions-filter"
                  labelId="committee-committee-sessions-filter-select-label"
                  multiple
                  value={selectedCommittees}
                  onChange={handleChangeCommittees}
                  renderValue={() => ""}
                >
                  {committees.map((item: any) => (
                    <MenuItem key={item} value={item}>
                      <Checkbox checked={selectedCommittees.indexOf(item) > -1} />
                      <ListItemText primary={item} style={{ width: 'fit-content' }} />
                    </MenuItem>
                  ))}
                </Select>

              </FormControl>
            </div>
          ) : null
          }

          {/* SubGroup  filter */}
          {displayfilters?.subgroup === 1 ? (

            <div data-span="2">
              <FormControl variant="filled" id={
            darkTheme === '1' ? 'filterApp' : 'noFilterApp'}  fullWidth>
                <InputLabel id="subgroup-sessions-filter-select-label"
                 style={darkTheme === '1' ? selectLabelStyleDark : selectLabelStyleLight}
                  disableAnimation={true}
                  shrink={false}
                >
                  Sub-Group
                </InputLabel>

                <Select
                  sx={darkTheme === '1' ? selectIconDark : selectIconLight}
                  inputProps={{ MenuProps: { MenuListProps: { sx: darkTheme === '1' ? selectPropsStyleDark : selectPropsStyleLight } } }}
                  IconComponent={ChevronDown}
                  variant="filled"
                  style={darkTheme === '1' ? selectLabelStyleDark : selectLabelStyleLight}
                  id="subgroup-sessions-filter"
                  labelId="subgroup-sessions-filter-select-label"
                  multiple
                  value={selectedSubGroups}
                  onChange={handleChangeSubGroups}
                  renderValue={() => ""}
                >
                  {subgroups.map((item: any) => (
                    <MenuItem key={item} value={item}>
                      <Checkbox checked={selectedSubGroups.indexOf(item) > -1} />
                      <ListItemText primary={item} style={{ width: 'fit-content' }} />
                    </MenuItem>
                  ))}
                </Select>

              </FormControl>
            </div>
          ) : null
          }


          {/* Venue  filter */}
          {displayfilters?.venue === 1 ? (
            <div data-span="2">
              <FormControl variant="filled" id={
            darkTheme === '1' ? 'filterApp' : 'noFilterApp'}  fullWidth>
                <InputLabel id="venue-sessions-filter-select-label"
                  style={darkTheme === '1' ? selectLabelStyleDark : selectLabelStyleLight}
                  disableAnimation={true}
                  shrink={false}
                >
                  Room
                </InputLabel>

                <Select
                 sx={darkTheme === '1' ? selectIconDark : selectIconLight}
                 inputProps={{ MenuProps: { MenuListProps: { sx: darkTheme === '1' ? selectPropsStyleDark : selectPropsStyleLight } } }}
                 IconComponent={ChevronDown}
                 variant="filled"
                 style={darkTheme === '1' ? selectLabelStyleDark : selectLabelStyleLight}
                  id="venue-sessions-filter"
                  labelId="venue-sessions-filter-select-label"
                  multiple
                  value={selectedVenues}
                  onChange={handleChangeVenues}
                  renderValue={() => ""}
                >
                  {venues.map((item: any) => (
                    <MenuItem key={item} value={item}>
                      <Checkbox checked={selectedVenues.indexOf(item) > -1} />
                      <ListItemText primary={item} style={{ width: 'fit-content' }} />
                    </MenuItem>
                  ))}
                </Select>

              </FormControl>
            </div>
          ) : null
          }

          {/* Agendaitems  filter */}
          {displayfilters?.agendaitem === 1 ? (
            <div data-span="2">
              <FormControl variant="filled" id={
            darkTheme === '1' ? 'filterApp' : 'noFilterApp'}  fullWidth>
                <InputLabel id="agendaitems-sessions-filter-select-label"
                  style={darkTheme === '1' ? selectLabelStyleDark : selectLabelStyleLight}
                  disableAnimation={true}
                  shrink={false}
                >
                  Agenda Items
                </InputLabel>

                <Select
                  sx={darkTheme === '1' ? selectIconDark : selectIconLight}
                  inputProps={{ MenuProps: { MenuListProps: { sx: darkTheme === '1' ? selectPropsStyleDark : selectPropsStyleLight } } }}
                  IconComponent={ChevronDown}
                  variant="filled"
                  style={darkTheme === '1' ? selectLabelStyleDark : selectLabelStyleLight}
                  id="agendaitems-sessions-filter"
                  labelId="agendaitems-sessions-filter-select-label"
                  multiple

                  value={selectedAgendaitems}
                  onChange={handleChangeAgendaitems}
                  renderValue={() => ""}
                >
                  {agendaitems.map((item: any) => (
                    <MenuItem key={item} value={item}>
                      <Checkbox checked={selectedAgendaitems.indexOf(item) > -1} />
                      <ListItemText primary={item} style={{ width: 'fit-content' }} />
                    </MenuItem>
                  ))}
                </Select>

              </FormControl>
            </div>
          ) : null
          }



        </div>
      </div>

      <div className='ituContainer '>
        <p id='numberOfResult'><strong>{cards.length}</strong> Sessions found</p>
      </div>

      {/* display filter chips component only if filters values are not null */}
      {
        filters.searchSession.length > 0 ||
        filters.DateSession.length > 0 ||
          filters.SectorSession.length > 0 ||
          filters.Venue.length > 0 ||
          filters.Committee.length > 0 ||
          filters.SubGroup.length > 0 ||
          filters.Venue.length > 0 ||
          filters.Agendaitem.length > 0
          ? (
            <FilterChips />
          ) : null
      }


      <div style={{ width: '100%', padding: '1rem 0 1.5rem 0', margin: "0px", paddingRight: "10px" }}>
        <div className='ituContainer' style={{ display: "flex", justifyContent: "space-between" }}>
          {
            eventid.length == 0
              ? (
                <ButtonComponent title="Events" onClick={navigateEvents} />
              ) : (

                <div style={{ visibility: 'hidden' }} >&nbsp;</div>

              )
          }
          <div>


            <ToggleButtonGroup
              id='togglebuttonmobile'
              color="primary"
              value={view}
              exclusive
              aria-label="View"
            >
              <ToggleButton value="card" aria-label="card" disableRipple disableFocusRipple disableTouchRipple onClick={(e) => setView('card')}>
                <HiOutlineViewGrid size="20" />&nbsp;Card view
              </ToggleButton>
              <ToggleButton value="list" aria-label="list" disableRipple disableFocusRipple disableTouchRipple onClick={(e) => setView('list')}>
                <List size="20" />&nbsp;List view
              </ToggleButton>
              {/* <ToggleButton value="calendar" aria-label="calendar" disableRipple disableFocusRipple disableTouchRipple onClick={(e) => setView('calendar')}>
              <Calendar size="20" />&nbsp;Calendar view
            </ToggleButton> */}

            </ToggleButtonGroup>

          </div>
        </div>
      </div>
    </>
  );
};

export default FilterBarSessions;
